"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var core_2 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var layout_1 = require("../util/layout");
exports.materialCategorizationStepperTester = core_2.rankWith(2, core_2.and(core_2.uiTypeIs('Categorization'), core_2.categorizationHasCategory, core_2.optionIs('variant', 'stepper')));
var MaterialCategorizationStepperLayoutRenderer = /** @class */ (function (_super) {
    __extends(MaterialCategorizationStepperLayoutRenderer, _super);
    function MaterialCategorizationStepperLayoutRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeCategory: 0
        };
        _this.handleStep = function (step) {
            _this.setState({ activeCategory: step });
        };
        return _this;
    }
    MaterialCategorizationStepperLayoutRenderer.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, path = _a.path, renderers = _a.renderers, schema = _a.schema, uischema = _a.uischema, visible = _a.visible;
        var categorization = uischema;
        var activeCategory = this.state.activeCategory;
        var childProps = {
            elements: categorization.elements[activeCategory].elements,
            schema: schema,
            path: path,
            direction: 'column',
            visible: visible,
            renderers: renderers
        };
        var categories = categorization.elements.filter(function (category) { return core_2.isVisible(category, data); });
        return (react_1.default.createElement(core_1.Hidden, { xsUp: !visible },
            react_1.default.createElement(core_1.Stepper, { activeStep: activeCategory, nonLinear: true }, categories.map(function (e, idx) {
                return (react_1.default.createElement(core_1.Step, { key: e.label },
                    react_1.default.createElement(core_1.StepButton, { onClick: function () { return _this.handleStep(idx); } }, e.label)));
            })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(layout_1.MaterialLayoutRenderer, __assign({}, childProps)))));
    };
    return MaterialCategorizationStepperLayoutRenderer;
}(react_2.RendererComponent));
exports.MaterialCategorizationStepperLayoutRenderer = MaterialCategorizationStepperLayoutRenderer;
exports.default = react_2.withJsonFormsLayoutProps(MaterialCategorizationStepperLayoutRenderer);
//# sourceMappingURL=MaterialCategorizationStepperLayout.js.map